import React from 'react';
import PropTypes from 'prop-types';

const FormHidden = (props) => {
  const { name, value, meta: { touched, error } } = props;
  const hasError = touched && error;
  return (
    <div>
      <input name={name} type="hidden" value={value} />
      {hasError &&
      <span className="form-validation-message">{error}</span>
      }
    </div>
  );
};

FormHidden.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  meta: PropTypes.object
};

export default FormHidden;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormHidden/FormHidden.js
 **/